require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[10],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(179);


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _CodeSnippet = _interopRequireDefault(__webpack_require__(180));

exports["default"] = _CodeSnippet["default"];
exports.CodeSnippet = _CodeSnippet["default"];

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes;

var CodeSnippet = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(CodeSnippet, _Component);

  function CodeSnippet() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = CodeSnippet.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        ariaLabel = _this$props.ariaLabel,
        children = _this$props.children,
        onClick = _this$props.onClick,
        type = _this$props.type,
        wrapText = _this$props.wrapText,
        buttonAriaLabel = _this$props.buttonAriaLabel,
        editable = _this$props.editable,
        height = _this$props.height,
        labelFormatter = _this$props.labelFormatter,
        onCopy = _this$props.onCopy,
        singleLinePaste = _this$props.singleLinePaste,
        value = _this$props.value,
        width = _this$props.width,
        otherCodeSnippetProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["ariaLabel", "children", "onClick", "type", "wrapText", "buttonAriaLabel", "editable", "height", "labelFormatter", "onCopy", "singleLinePaste", "value", "width"]);
    var mappedAriaLabel = ariaLabel != null ? ariaLabel : buttonAriaLabel;
    var mappedChildren = children != null ? children : value;
    var mappedOnClick = onClick != null ? onClick : onCopy;
    var mappedType = type != null ? type : 'multi';
    var mappedWrapText = wrapText != null ? wrapText : true;
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.CodeSnippet, (0, _extends2["default"])({}, otherCodeSnippetProps, {
      ariaLabel: mappedAriaLabel,
      onClick: mappedOnClick,
      type: mappedType,
      wrapText: mappedWrapText
    }), mappedChildren);
  };

  return CodeSnippet;
}(_react.Component);

exports["default"] = CodeSnippet;
(0, _defineProperty2["default"])(CodeSnippet, "propTypes", (0, _extends2["default"])({}, _baUiCarbon.CodeSnippet.propTypes, {
  /** deprecated - use ariaLabel */
  buttonAriaLabel: BaPropTypes.deprecated('deprecated - use ariaLabel'),

  /** deprecated - not supported in Carbon */
  editable: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - not supported in Carbon */
  height: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - not supported in Carbon */
  labelFormatter: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - use onClick */
  onCopy: BaPropTypes.deprecated('deprecated - use onClick'),

  /** deprecated - not supported in Carbon */
  singleLinePaste: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - send value as children in Carbon */
  value: BaPropTypes.deprecated('deprecated - send value as children in Carbon'),

  /** deprecated - not supported in Carbon */
  width: BaPropTypes.deprecated('deprecated - not supported in Carbon')
}));

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ })

},[[178,0]]]);
});